import React from 'react';
import { Chip } from '@mui/joy';
import { getDocumentDisplayName } from '../../../helpers/documentNames';
import { createDocumentMentionRegex } from '../../../helpers/documentMentions';

const DOCUMENT_MENTION_REGEX = createDocumentMentionRegex('g');
const POLICY_MENTION_REGEX = /@policy:([^\s:)]+)/g;
const TASK_MENTION_REGEX = /@task:([^\s:)]+)/g;

export const parseMessageContent = (content) => {
  if (!content) return [{ type: 'text', content: '' }];

  const combinedRegex = new RegExp(
    `(${DOCUMENT_MENTION_REGEX.source})|(${POLICY_MENTION_REGEX.source})|(${TASK_MENTION_REGEX.source})`,
    'g'
  );

  const segments = [];
  let lastIndex = 0;

  for (const match of content.matchAll(combinedRegex)) {
    if (match.index > lastIndex) {
      segments.push({ type: 'text', content: content.slice(lastIndex, match.index) });
    }

    if (match[1]) {
      const filePath = match[2];
      const fileName = getDocumentDisplayName(filePath) || filePath;
      segments.push({ type: 'document', filePath, fileName, fullMatch: match[0] });
    } else if (match[3]) {
      const [policyId, fieldKey] = match[4].split('/');
      segments.push({ type: 'policy', policyId, fieldKey, fullMatch: match[0] });
    } else if (match[5]) {
      const taskId = match[6];
      segments.push({ type: 'task', taskId, fullMatch: match[0] });
    }

    lastIndex = match.index + match[0].length;
  }

  if (lastIndex < content.length) {
    segments.push({ type: 'text', content: content.slice(lastIndex) });
  }

  if (segments.length === 0) {
    segments.push({ type: 'text', content: content });
  }

  return segments;
};

export const PolicyChip = ({ policyId, fieldKey, onClick }) => (
  <Chip
    size="sm"
    variant="soft"
    color="success"
    onClick={onClick}
    sx={{
      cursor: 'pointer',
      mx: 0.5,
      verticalAlign: 'middle',
      fontWeight: 500,
      fontSize: '0.75rem',
    }}
    startDecorator="📋"
  >
    Policy {policyId}{fieldKey ? ` › ${fieldKey}` : ''}
  </Chip>
);

export const TaskChip = ({ taskId, onClick }) => (
  <Chip
    size="sm"
    variant="soft"
    color="warning"
    onClick={onClick}
    sx={{
      cursor: 'pointer',
      mx: 0.5,
      verticalAlign: 'middle',
      fontWeight: 500,
      fontSize: '0.75rem',
    }}
    startDecorator="✓"
  >
    Task {taskId}
  </Chip>
);
